import dates from "@/services/date";

export default {
  methods: {
    olderThanNow: function(timeString) {
      let dt = dates.parseJsonDate(timeString);
      if (dates.isValid(dt)) {
        return dates.pastDate(timeString);
      }
      return true;
    }
  }
}
